export const PROMO_MELHOR_DIA_LABEL = "Qual o melhor dia do mês para compras para você?";
export const PROMO_PAGAMENTO_LABEL = "Qual método de pagamento você prefere?";
export const PROMO_MELHOR_DIA_NAME = "promo_melhor_dia_mes";
export const PROMO_PAGAMENTO_NAME = "promo_forma_pagamento";

export const PROMO_MELHOR_DIA_OPTIONS = [
  "Dia 1 ao dia 10",
  "Dia 10 ao dia 20",
  "Dia 20 ao dia 30",
];

export const PROMO_PAGAMENTO_OPTIONS = [
  "À vista no PIX",
  "Cartão parcelado — 3x",
  "Cartão parcelado — 6x",
  "Cartão parcelado — 9x",
  "Cartão parcelado — 12x",
];

export function isPromoCompraSurvey(survey) {
  if (!survey) return false;
  const title = String(survey.title || "").toLowerCase();
  if (title.includes("quando e como") || (title.includes("prefere") && title.includes("compra"))) {
    return true;
  }
  const fields = survey.fields || [];
  const names = new Set(fields.map((f) => f.name));
  return names.has(PROMO_MELHOR_DIA_NAME) || names.has(PROMO_PAGAMENTO_NAME);
}

export function normalizePromoCompraSurveyFields() {
  return [
    {
      name: PROMO_MELHOR_DIA_NAME,
      label: PROMO_MELHOR_DIA_LABEL,
      type: "radio",
      options: [...PROMO_MELHOR_DIA_OPTIONS],
      required: true,
    },
    {
      name: PROMO_PAGAMENTO_NAME,
      label: PROMO_PAGAMENTO_LABEL,
      type: "radio",
      options: [...PROMO_PAGAMENTO_OPTIONS],
      required: true,
    },
  ];
}

export function displayFieldLabel(field) {
  if (field?.name === PROMO_MELHOR_DIA_NAME) return PROMO_MELHOR_DIA_LABEL;
  if (field?.name === PROMO_PAGAMENTO_NAME) return PROMO_PAGAMENTO_LABEL;
  return field?.label || "";
}

export function isEmptyAnswer(field, value) {
  return !value;
}

export function isSurveyComplete(fields, answers) {
  if (!Array.isArray(fields)) return false;
  return fields.every(
    (field) => !field.required || !isEmptyAnswer(field, answers[field.name]),
  );
}
